// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styles for PrintableOrderAppendix */
.printable-order-appendix-container {
    font-family: 'Times New Roman', Times, serif; /* Mimic document style */
    font-size: 12pt; /* Standard document font size */
    line-height: 1.4;
    padding: 2cm; /* Standard A4 margins */
    background-color: #fff;
    color: #000;
    max-width: 210mm; /* A4 width */
    margin: auto; /* Center on screen if needed */
}

.appendix-header {
    text-align: center;
    margin-bottom: 30px;
}

.appendix-header h2 {
    font-size: 14pt;
    font-weight: bold;
    margin-bottom: 10px;
}

.appendix-body {
    margin-bottom: 40px;
}

.appendix-body h3 {
    font-size: 12pt;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
}

.appendix-body p {
    margin-bottom: 10px;
    text-indent: 1.25cm; /* Standard paragraph indent */
    text-align: justify;
}

/* Remove indent for specific paragraphs if needed */
.appendix-body p:first-of-type {
    text-indent: 0;
}
.appendix-body h3 + p { /* Paragraphs directly after h3 */
     text-indent: 0;
}
.appendix-body .items-table + h3 { /* Heading after table */
    margin-top: 30px;
}


.items-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 11pt;
}

.items-table th,
.items-table td {
    border: 1px solid #000;
    padding: 5px 8px;
    text-align: left;
    vertical-align: top;
}

.items-table th {
    background-color: #f2f2f2; /* Light gray header */
    font-weight: bold;
    text-align: center;
}

.items-table td:nth-child(3), /* Price */
.items-table td:nth-child(4), /* Quantity */
.items-table td:nth-child(6) { /* Total */
    text-align: right;
}
.items-table tfoot td {
    border: none;
    font-weight: bold;
    padding-top: 10px;
}


.appendix-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    font-size: 11pt;
}

.party-details {
    width: 45%;
}

.party-details h4 {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 12pt;
}

.party-details p {
    margin-bottom: 5px;
    text-indent: 0; /* No indent for details */
    text-align: left;
}

/* Print-specific styles */
@media print {
    body, html {
        margin: 0;
        padding: 0;
        background-color: #fff; /* Ensure white background for printing */
    }
    .printable-order-appendix-container {
        padding: 0; /* Remove padding for print */
        margin: 0;
        box-shadow: none; /* Remove shadow for print */
        max-width: 100%;
        border: none;
    }
    /* Hide elements not meant for printing if any */
    .no-print {
        /* display: none; */
    }
    /* Ensure page breaks are handled reasonably */
    .appendix-footer {
        page-break-inside: avoid;
    }
    table {
        page-break-inside: auto;
    }
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    thead {
        display: table-header-group; /* Repeat table header on each page */
    }
    tfoot {
        display: table-footer-group;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableOrderAppendix.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;IACI,4CAA4C,EAAE,yBAAyB;IACvE,eAAe,EAAE,gCAAgC;IACjD,gBAAgB;IAChB,YAAY,EAAE,wBAAwB;IACtC,sBAAsB;IACtB,WAAW;IACX,gBAAgB,EAAE,aAAa;IAC/B,YAAY,EAAE,+BAA+B;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB,EAAE,8BAA8B;IACnD,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,cAAc;AAClB;AACA,wBAAwB,iCAAiC;KACpD,cAAc;AACnB;AACA,mCAAmC,wBAAwB;IACvD,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,sBAAsB;IACjD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;+BAE+B,UAAU;IACrC,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc,EAAE,0BAA0B;IAC1C,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI;QACI,SAAS;QACT,UAAU;QACV,sBAAsB,EAAE,yCAAyC;IACrE;IACA;QACI,UAAU,EAAE,6BAA6B;QACzC,SAAS;QACT,gBAAgB,EAAE,4BAA4B;QAC9C,eAAe;QACf,YAAY;IAChB;IACA,gDAAgD;IAChD;QACI,mBAAmB;IACvB;IACA,8CAA8C;IAC9C;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;IACA;QACI,2BAA2B,EAAE,qCAAqC;IACtE;IACA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":["/* Basic styles for PrintableOrderAppendix */\n.printable-order-appendix-container {\n    font-family: 'Times New Roman', Times, serif; /* Mimic document style */\n    font-size: 12pt; /* Standard document font size */\n    line-height: 1.4;\n    padding: 2cm; /* Standard A4 margins */\n    background-color: #fff;\n    color: #000;\n    max-width: 210mm; /* A4 width */\n    margin: auto; /* Center on screen if needed */\n}\n\n.appendix-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.appendix-header h2 {\n    font-size: 14pt;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.appendix-body {\n    margin-bottom: 40px;\n}\n\n.appendix-body h3 {\n    font-size: 12pt;\n    font-weight: bold;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n.appendix-body p {\n    margin-bottom: 10px;\n    text-indent: 1.25cm; /* Standard paragraph indent */\n    text-align: justify;\n}\n\n/* Remove indent for specific paragraphs if needed */\n.appendix-body p:first-of-type {\n    text-indent: 0;\n}\n.appendix-body h3 + p { /* Paragraphs directly after h3 */\n     text-indent: 0;\n}\n.appendix-body .items-table + h3 { /* Heading after table */\n    margin-top: 30px;\n}\n\n\n.items-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    font-size: 11pt;\n}\n\n.items-table th,\n.items-table td {\n    border: 1px solid #000;\n    padding: 5px 8px;\n    text-align: left;\n    vertical-align: top;\n}\n\n.items-table th {\n    background-color: #f2f2f2; /* Light gray header */\n    font-weight: bold;\n    text-align: center;\n}\n\n.items-table td:nth-child(3), /* Price */\n.items-table td:nth-child(4), /* Quantity */\n.items-table td:nth-child(6) { /* Total */\n    text-align: right;\n}\n.items-table tfoot td {\n    border: none;\n    font-weight: bold;\n    padding-top: 10px;\n}\n\n\n.appendix-footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 50px;\n    font-size: 11pt;\n}\n\n.party-details {\n    width: 45%;\n}\n\n.party-details h4 {\n    font-weight: bold;\n    margin-bottom: 10px;\n    font-size: 12pt;\n}\n\n.party-details p {\n    margin-bottom: 5px;\n    text-indent: 0; /* No indent for details */\n    text-align: left;\n}\n\n/* Print-specific styles */\n@media print {\n    body, html {\n        margin: 0;\n        padding: 0;\n        background-color: #fff; /* Ensure white background for printing */\n    }\n    .printable-order-appendix-container {\n        padding: 0; /* Remove padding for print */\n        margin: 0;\n        box-shadow: none; /* Remove shadow for print */\n        max-width: 100%;\n        border: none;\n    }\n    /* Hide elements not meant for printing if any */\n    .no-print {\n        /* display: none; */\n    }\n    /* Ensure page breaks are handled reasonably */\n    .appendix-footer {\n        page-break-inside: avoid;\n    }\n    table {\n        page-break-inside: auto;\n    }\n    tr {\n        page-break-inside: avoid;\n        page-break-after: auto;\n    }\n    thead {\n        display: table-header-group; /* Repeat table header on each page */\n    }\n    tfoot {\n        display: table-footer-group;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
